import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import RouterStore from '../../store/RouterStore';

interface IPropsBotao {
    redirectTo: string;
    controleNumero?: number;
    pathnameConfig: string[];
    label: string;
    handleOnTouchTap?: (event) => any;
    disabled?: boolean;
    startIcon?: React.ReactNode;
}


class Botao extends React.Component<IPropsBotao> {

    redirecionar = () => {
        RouterStore.push(
            this.props.redirectTo +
            (this.props.controleNumero ? `?controleNumero=${this.props.controleNumero}` : '')
        );
    };

    renderButton(onClick?) {
        return (
            <Button
                variant="contained"
                color="primary"
                disabled={this.props.disabled}
                onClick={onClick}
                startIcon={this.props.startIcon}
                sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    paddingX: '18px',
                    paddingY: '8px',
                    minHeight: '40px',
                    borderRadius: '50px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    }
                }}
            >
                {this.props.label}
            </Button>
        );
    }

    render() {
        const isConfig = this.props.pathnameConfig.includes(RouterStore.lastRoute);

        if (isConfig) {
            return <div>{this.renderButton()}</div>;
        }

        if (this.props.handleOnTouchTap) {
            return <div>{this.renderButton(this.props.handleOnTouchTap)}</div>;
        }

        return <div>{this.renderButton(this.redirecionar)}</div>;
    }
}

export default observer(Botao);
